module.exports = "<span class=\"aggregate-header-left lead\"><i class=\"icon-filter\" style=\"color:#fff\"></i>&nbsp; </span><span class=\"dimensions-header-center\"><input type=\"text\" id=\"search-keyword\" class=\"search-keyword\" ng-keyup=\"$ctrl.searchKeyup($event)\" placeholder=\"{{:: 'Поиск - Ключевые слова' | gettext }}\" ng-model=\"$ctrl.value\"> </span><span class=\"ztop add-on dimensions-header-right\"><a title=\"{{:: 'Полнотекстовый поиск' | gettext }}\"><i class=\"icon-search\" ng-click=\"$ctrl.search()\"></i> </a></span>"


//////////////////
// WEBPACK FOOTER
// ./src/filter/filter-search.component.html
// module id = 284
// module chunks = 0